import * as React from 'react';
import { EventFunc } from '../../types/types';
import './ButtonAction.pcss';

interface Props {
  onClick:EventFunc;
  children:any;
  disabled?:boolean;
  className?:string;
  buttonActionIsBroken:boolean;
  ariaLabel?:string;
}

/**
 * The goal of this component is to provide an analog to an
 * anchor link that does not require an href value in order
 * to be included in the tab order, and responds to the
 * enter key like other buttons.
 *
 * @param props
 * @constructor
 */
export const ButtonAction = (props:Props) =>
    <button

        disabled={props.disabled}
        className={`button-action${props.disabled?' disabled':''} ${props.className?props.className:''} inset-three-band-focus`}
        onClick={(e)=>{ props.onClick(e); return false; }}
        aria-label={props.ariaLabel}
        tabIndex={0}
    >
      {props.children}
    </button>
;

